module.exports = __webpack_public_path__ + "static/media/processing.65bda22a.svg";